import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugDesipramine} from "./TextDrugDesipramine"


export default function Desipramine() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
 
    <ButtonsText onClick={handleOpen} name='Desipramine' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Desipramine - PGx Recommendation"
        content={ <TextDrugDesipramine />}

        />

</>
)}